import {
  Component,
  Injectable,
  Input,
  ElementRef,
  ViewChild,
  TemplateRef,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { Select2TemplateFunction, Select2OptionData } from 'ng2-select2';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { UserService } from '../../../../../common/services/User.service';
import * as _ from 'lodash';
import { FieldService } from '../../../../../common/services/Field.service';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { CommentService } from '../../../../../common/services/Comment.service';
import { ApiEvsService } from '../../../../../common/services/ApiEvs.service';
import { ContactService } from '../../../../../common/services/Contact.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { UtilityService } from 'app/common/services/Utility.service';
import { UserSharedService } from '../../customer/UserSharedService';
import { CustomerType, Gender, RoleForCustomer, RoleForAgent } from './detail_user.const';
import { Role } from '../../setting/expert/expert.const';
import { showPhoneNumberInString } from '../../../../../common/utils/common';
import { BaseComponent } from '../../../../../components/base.component';
import { Observable } from 'rxjs/Observable';

declare var $: any;
declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'detail-user',
  templateUrl: './detail_user.component.html',
  styleUrls: ['../detail.css', './user.css'],
  providers: [
    BsModalService,
    GroupService,
    OrganizeService,
    EvsAddressService,
    UserService,
    FieldService,
    CommonService,
    UploadService,
    CommentService,
    ApiEvsService,
    ContactService,
  ],
})
@Injectable()
export class DetailUserComponent extends BaseComponent {
  public no_image: any = 'assets/images/contact.png';
  @Input() owner;
  @Input() tabIndex;
  @Output('comeback') comeback = new EventEmitter();
  @Output('appendDataUser') appendDataUser = new EventEmitter();
  public displayName: string = '';

  public option_group: any = {};
  public option_organize: any = {};
  public allRole: any = [{ id: '', text: '' }];
  public allGroup: any = [{ id: '', text: '' }];
  public allUserGroup: any = [{ id: '', text: '' }];
  public allAccessContact: any = [{ id: '', text: '' }];
  public allAccessTicket: any = [{ id: '', text: '' }];
  public ruleChat: any = [{ id: '', text: '' }];
  public allOrganize: any = [{ id: '', text: '' }];
  public allGender: any = [{ id: '', text: '' }];
  public cities: any = [{ id: '', text: '' }];
  public districts: any = [{ id: '', text: '' }];
  public allStatus: any = [];
  public allFillterGroup: any = [];
  public allUserFillterGroup: any = [];
  public modelGroup: any = {};
  public modelOrganize: any = {};
  public fields: any = [];
  public errorUpdate: any = [];

  public addPhone = false;
  public addEmail = false;
  public addFacebook = false;
  public deletePhone = true;
  public deleteEmail = true;
  public changed_email = false;
  public deleteFacebook = true;
  public change_name = false;
  public tab = 'ticket';
  public tickets: any = {};
  public currentPage: any = {};
  public totalItem: any = {};
  public totalPage: any = {};
  public page_size = 10;
  public filter_type: any = 'request'; // request | assign || reciver
  public total = 0;

  public selected: any = {};
  public fast_status: any;
  public changed_phone = false;

  public modelFilter: any = {};
  public is_load_data = false;
  public customerType: any = [];
  public isSelected: any = { 1: false, 2: false, 3: false, 4: false, 5: false };
  public is_add_org = false;
  public is_load_district_follow_city = false;
  public payload_tmp: any = {};
  @ViewChild('templateGroup') templateGroup: ElementRef;
  @ViewChild('templateOrganize') templateOrganize: ElementRef;
  @ViewChild('templateMergeUser') templateMergeUser: ElementRef;
  @ViewChild('templateAgent') templateAgent: ElementRef;
  @ViewChild('templateStatus') templateStatus: ElementRef;
  public readonly Role = Role;

  protected readonly showPhoneNumberInString = showPhoneNumberInString;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private groupService: GroupService,
    private organizeService: OrganizeService,
    private addressService: EvsAddressService,
    private userService: UserService,
    private fieldService: FieldService,
    private socketService: SocketService,
    private uploadService: UploadService,
    private commonService: CommonService,
    private shareService: UserSharedService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    Observable.forkJoin([
      this.groupService.allGroup({ target: 'user' }),
      this.groupService.allGroup({ target: 'end_user' }),
      this.organizeService.allOrganize(),
      this.addressService.getCities(),
      this.fieldService.allField({ target: 'user' }),
    ]).subscribe(data => {
      this.customerType = ['--Chọn--', { id: '', text: '' }, ...CustomerType];
      this.loadUserGroup(data[0]);
      this.loadContactGroup(data[1]);
      this.loadOrganizes(data[2]);
      this.loadCities(data[3]);
      this.loadUserFields(data[4]);
      this.getRoles();
      this.getAccessTicket();
      this.getAccessContact();
      this.getRuleChat();
      this.getGender();
      if (this.owner.city_id) {
        this.loadDistricts(this.owner.city_id);
      }
      this.option_group = {
        placeholder: { id: '', text: '-Chọn-' },
        templateResult: this.templateResult,
        templateSelection: this.templateSelection,
      };

      this.option_organize = {
        placeholder: { id: '', text: '-Chọn-' },
        templateResult: this.templateResult,
        templateSelection: this.templateSelection,
      };
      this.getUser();
    });
  }

  loadUserGroup(res) {
    if (res.status == 200 && !res.error) {
      const groupList = [];
      const tmp_groupList = [];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
        tmp_groupList.push({
          text: c.name,
          id: c.id,
        });
        this.allFillterGroup = [
          {
            id: '',
            text: '-Chọn-',
          },
          ...tmp_groupList,
        ];
        this.allGroup = [
          {
            id: '',
            text: '-Chọn-',
          },
          ...groupList,
        ];
      });
    }
  }

  loadContactGroup(res) {
    if (res.status == 200 && !res.error) {
      const groupList = [];
      const tmp_groupList = [];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
        tmp_groupList.push({
          text: c.name,
          id: c.id,
        });
        this.allUserFillterGroup = [
          {
            id: '',
            text: '-Chọn-',
          },
          ...tmp_groupList,
        ];
        this.allUserGroup = [
          {
            id: '',
            text: '-Chọn-',
          },
          ...groupList,
        ];
      });
    }
  }

  loadOrganizes(res) {
    if (res.status == 200 && !res.error) {
      const organizeList = [];
      res.data.forEach((c: any) => {
        organizeList.push({
          text: c.name,
          id: c.organize_id,
        });
      });
      this.allOrganize = [
        {
          id: '',
          text: '--Chọn--',
        },
        ...organizeList,
      ];
    }
  }

  loadCities(res) {
    if (res.status == 200 && !res.error) {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.cities = [
        {
          id: '',
          text: '--Chọn--',
        },
        ...citiesList,
      ];
    }
  }

  loadDistricts(id) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then(res => {
        if (res.status == 200 && !res.error) {
          const districts = [
            {
              id: '',
              text: '--Chọn--',
            },
          ];
          res.data.districts.forEach((c: any) => {
            districts.push({
              text: c.name,
              id: c.id,
            });
          });
          this.districts = districts;
        }
      });
  }

  loadUserFields(res) {
    if (res.status == 200 && !res.error) {
      this.fields = res.data;
      this.fields.forEach(element => {
        if (element.type == 'select') {
          element.data.unshift('--Chọn--');
        }
      });
    }
  }

  getUser() {
    this.userService.find({ _id: this.owner._id }).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.model = _.assign({}, res.data);
          this.model.dob = this.model.dob || null;
        } else {
          this.model = _.assign({}, this.owner);
        }
      },
      () => {
        this.model = _.assign({}, this.owner);
      },
      () => {
        this.displayName = showPhoneNumberInString(this.model.name, this.user);
        this.getRoles(this.model);
        if (this.model.tags) {
          if (typeof this.model.tags == 'string') {
            let arr_tags = this.model.tags.split(',');
            arr_tags = _.map(arr_tags, e => {
              return {
                displayValue: e,
              };
            });
            this.model.tags = arr_tags;
          } else {
            this.model.tags = this.model.tags.map(e => ({
              displayValue: e,
            }));
          }
        } else {
          this.model.tags = [];
        }

        if (this.model.facebook && this.model.facebook.constructor.toString().indexOf('Array') == -1) {
          this.model.facebook = [this.model.facebook];
        }

        this.model.$addToSet = {};
        this.model.$pull = {};
        console.log(this.model);
      }
    );
  }

  initTabUser() {
    this.model.quota_chat = this.owner.quota_chat;
    delete this.model.password;
    delete this.model.confirm_password;
  }

  resetPass(template: TemplateRef<any>) {
    this.message = null;
    if (!this.model.password || !this.model.confirm_password) {
      this.toastr.error('Mật khẩu chưa được nhập', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else if (this.model.password.trim() != this.model.confirm_password.trim()) {
      this.toastr.error('Mật khẩu không chính xác', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else if (this.model.password.length < 6) {
      this.toastr.error('Mật khẩu nhiều hơn 6 ký tự', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      const config = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
      };
      this.modalRef = this.modalService.show(template, config);
    }
  }

  submitChangePass() {
    this.modalRef.hide();
    this.userService.resetPass(this.owner._id, { password: this.model.password }).subscribe(res => {
      if (res.error == false && res.status == 200) {
        this.toastr.success('Thay đổi mật khẩu thành công', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.model.password = this.model.confirm_password = '';
      } else {
        this.toastr.error('Thay đổi mật khẩu không thành công', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  updateConfigUser() {
    delete this.model.password;
    delete this.model.confirm_password;
    if (this.model && this.model.quota_chat < 0) {
      this.errorUpdate.push('Giới hạn tiếp nhận chat không hợp lệ');
    } else {
      this.updateUser();
    }
  }

  uploadAvatar() {
    $('#avatar_' + this.model._id).trigger('click');
  }

  changeAvatar($event) {
    const files = $event.srcElement.files;
    const file = files[0];
    if (file.size > 2 * 1024 * 1024) {
      this.toastr.error('Dung lượng file tối đa 2Mb', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (/.*\.(png|jpg|jpeg)$/.test(file.name.toLowerCase()) == false) {
      this.toastr.error('Định dạng file gửi không đúng (png, jpg, jpeg)', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error) {
        this.model.avatar = this.commonService.file(res.data);
        // this.updateUser({ avatar: this.model.avatar });
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  openTicket(ticket: any) {
    this.userService
      .find({ _id: ticket.requester_id })
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          ticket.request = res.data;
          this.socketService.opentab(ticket, 'ticket', 'edit');
          this.shareService.onChangetab.emit('ticket');
        }
      });
  }

  getGender() {
    this.allGender = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
      ...Gender,
    ];
  }

  getRoles(user?: any) {
    this.allRole = [{ id: '', text: '' }];
    if (user) {
      if (user.role && user.role == 'end_user') {
        this.allRole = [...this.allRole, ...RoleForCustomer];
      } else if (user.role && user.role != 'end_user') {
        this.allRole = [...this.allRole, ...RoleForAgent];
      } else {
        this.allRole = [...this.allRole, ...RoleForCustomer, ...RoleForAgent];
      }
    } else {
      this.allRole = [...this.allRole, ...RoleForCustomer, ...RoleForAgent];
    }
  }

  getAccessTicket() {
    this.allAccessTicket = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
      {
        id: 'access-all-ticket',
        text: 'Truy cập toàn bộ ticket',
      },
      {
        id: 'access-my-ticket',
        text: 'Truy cập ticket của mình',
      },
      {
        id: 'access-group-ticket',
        text: 'Truy cập ticket của nhóm',
      },
      {
        id: 'access-org-ticket',
        text: 'Truy cập ticket của tổ chức',
      },
    ];
  }

  getAccessContact() {
    this.allAccessContact = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
      {
        id: 'access-all-contact',
        text: 'Truy cập toàn bộ khách hàng',
      },
      {
        id: 'access-my-contact',
        text: 'Truy cập khách hàng của mình',
      },
      {
        id: 'access-group-contact',
        text: 'Truy cập khách hàng của bộ phận',
      },
      {
        id: 'access-org-contact',
        text: 'Truy cập khách hàng của tổ chức',
      },
    ];
  }

  getRuleChat() {
    this.ruleChat = [
      '--Chọn--',
      {
        id: '',
        text: '',
      },
      {
        id: 'all-rule',
        text: 'All rule',
      },
      {
        id: 'only-text',
        text: 'Chat Text & Ảnh',
      },
      {
        id: 'only-file',
        text: 'Chat Text & File đính kèm',
      },
    ];
  }

  changedName($event) {
    this.model.name = $event.trim();
    this.displayName = showPhoneNumberInString($event, this.user);
  }

  saveField(field, key) {
    if (this.model[key] && moment(this.model[key], 'YYYY-MM-DD', true).isValid()) {
      this.model[key] = moment(this.model[key]).format('YYYY-MM-DD');
    }
    if (this.model[key]) {
      this.model[key] = this.model[key].toString().trim();
      // this.updateUser(payload);
    } else {
      this.model[key] = '';
      // this.updateUser(payload);
    }
    // }
  }

  changedValueMyField(e, field, key) {
    if (!this.is_load_data) {
      const payload = {};
      if (e.value == '--Chọn--') {
        // payload[key] = '';
        this.model[key] = '';
      } else {
        // payload[key] = e.value;
        this.model[key] = e.value;
      }
    }
  }

  deleteMoreItem(type, value?: any) {
    switch (type) {
      case 'phone': {
        this.deletePhone = false;
        if (!value) {
          // this.updateUser({ phone: '' });
          this.model.phone = '';
        } else {
          // this.updateUser({ $pull: { sub_phone: value } })
          this.model.$pull.sub_phone = value;
          this.model.sub_phone = _.pull(this.model.sub_phone, value);
        }
        break;
      }
      case 'email': {
        this.deleteEmail = false;
        if (value) {
          // this.updateUser({ $pull: { sub_email: value } })
          this.model.$pull.sub_email = value;
          this.model.sub_email = _.pull(this.model.sub_email, value);
        }
        break;
      }
      case 'facebook': {
        this.deleteFacebook = false;
        if (value) {
          // this.updateUser({ $pull: { facebook: value } })
          this.model.$pull.facebook = value;
          this.model.facebook = _.pull(this.model.facebook, value);
        }
        break;
      }
      default:
        break;
    }
  }

  addMore(type) {
    switch (type) {
      case 'phone': {
        if (this.model.more_phone && this.model.more_phone.trim() != '') {
          if (!this.model.phone) {
            this.payload_tmp.phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
          } else {
            this.model.$addToSet.sub_phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
          }
        }
        break;
      }
      case 'email': {
        if (this.model.more_email && this.model.more_email.trim() != '') {
          if (!this.model.email) {
            this.payload_tmp.email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
          } else {
            this.model.$addToSet.sub_email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
          }
        }
        break;
      }
      case 'facebook': {
        if (this.model.more_facebook && this.model.more_facebook.trim() != '') {
          this.model.$addToSet.facebook = this.model.more_facebook.trim();
        }
        break;
      }
      default:
        break;
    }
  }

  newTicket() {
    this.socketService.opentab({ request: this.owner }, 'ticket', 'new');
  }

  execCall(phone) {
    if (UtilityService.isValidPhoneNumber(phone)) {
      this.socketService.execCall(phone);
    } else {
      this.toastr.error('', 'Số điện thoại không hợp lệ', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  changedAddress() {
    if (this.model.address && this.model.address.trim() != '') {
      this.model.address = this.model.address.trim();
      // this.updateUser({ address: this.model.address.trim() })
    }
  }

  changedAgentId() {
    if (this.model.agent_id && this.model.agent_id.trim() != '') {
      this.model.agent_id = this.model.agent_id.trim();
      // this.updateUser({ agent_id: this.model.agent_id.trim() })
    }
  }

  changedNote() {
    if (this.model.note && this.model.note.trim() != '') {
      this.model.note = this.model.note.trim();
      // this.updateUser({ note: this.model.note.trim() })
    }
  }

  changedPhone() {
    if (this.model.phone && this.model.phone.trim() != '') {
      this.model.phone = this.model.phone.trim().replace(new RegExp(' ', 'g'), '');
    }
  }

  changedEmail() {
    if (this.model.email && this.model.email.trim() != '') {
      // this.updateUser({ email: this.model.email.trim() })
      this.model.email = this.model.email.trim();
    }
  }

  changedGender(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        // this.updateUser({ gender: e.value });
        this.model.gender = e.value;
      }
    }
  }

  changedCustomerType(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        // this.updateUser({ customer_type: e.value });
        this.model.customer_type = e.value;
      }
    }
  }

  changedCity(e: any) {
    if (!this.is_load_data) {
      if (e.value != '' && !isNaN(parseInt(e.value))) {
        // this.updateUser({ city_id: parseInt(e.value) });
        this.model.city_id = parseInt(e.value);
        this.loadDistricts(e.value);
      }
    } else {
      if (e.value != '') {
        this.loadDistricts(e.value);
      }
    }
  }

  changedDistrict(e: any) {
    if (!this.is_load_data && !this.is_load_district_follow_city) {
      if (e.value != '' && !isNaN(parseInt(e.value))) {
        // this.updateUser({ district_id: parseInt(e.value) });
        this.model.district_id = parseInt(e.value);
      }
    }
  }

  changedAccessContact(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        let payload = {};
        if (this.model.access) {
          payload = this.owner.access;
        }
        payload['contact'] = e.value;
        // this.updateUser({ access: payload });
        this.model.access = payload;
      }
    }
  }

  changedRuleChat(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        this.model.rule_chat = e.value;
        // this.updateUser({ rule_chat: e.value });
        // this.model.access = payload;
      }
    }
  }

  changedAccessTicket(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        let payload = {};
        if (this.model.access) {
          payload = this.owner.access;
        }
        payload['ticket'] = e.value;
        this.model.access = payload;
        // this.updateUser({ access: payload });
        // this.model.access = payload;
      }
    }
  }

  changedRole(e: any) {
    if (!this.is_load_data) {
      if (e.value != '') {
        this.model.role = e.value;
      }
    }
  }

  changedGroup(e: any): void {
    if (!this.is_load_data) {
      if (e.value == 'add') {
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(this.templateGroup, config);
      } else if (e.value != '') {
        this.model.group_id = parseInt(e.value);
        // this.updateUser({ group_id: parseInt(e.value) });
        // this.model.group_id = e.value;
      }
    }
  }

  changedOrganize(e: any) {
    if (!this.is_load_data) {
      if (e.value == 'add') {
        this.modelOrganize = {};
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
        };
        this.modalRef = this.modalService.show(this.templateOrganize, config);
      } else if (e.value != '' && typeof e.value != 'object') {
        // 'object' khi bấm huy, 'add' khi bấm lưu trong templateOrganize gọi thêm hàm updateUser
        if (e.value == '--Chọn--') {
          if (!this.is_add_org && !isNaN(Number(e.value))) {
            // this.updateUser({ organize_id: parseInt(e.value) });
            this.model.organize_id = parseInt(e.value);
          }
        } else {
          this.model.organize_id = parseInt(e.value);
          // this.updateUser({ organize_id: parseInt(e.value) });
        }

        // this.model.organize_id = e.value;
      }
    }
  }

  updateUser() {
    // abcde
    this.errorUpdate = [];
    let check = true;
    this.fields.forEach(e => {
      if (e.is_required) {
        if (e.type == 'number') {
          if (!this.model[e.key] && this.model[e.key] != '0') {
            check = false;
            this.errorUpdate.push('Thuộc tính ' + e.title + ' không được bỏ trống');
          }
        } else if (e.type == 'text' || e.type == 'textarea' || e.type == 'date') {
          if (!this.model[e.key] || (this.model[e.key] && this.model[e.key].trim() == '')) {
            check = false;
            this.errorUpdate.push('Thuộc tính ' + e.title + ' không được bỏ trống');
          }
        } else if (e.type == 'select') {
          if (!this.model[e.key] || this.model[e.key] == '--Chọn--') {
            check = false;
            this.errorUpdate.push('Thuộc tính ' + e.title + ' không được bỏ trống');
          }
        } else if (e.type == 'multi-select') {
          if (!this.model[e.key]) {
            check = false;
            this.errorUpdate.push('Thuộc tính ' + e.title + ' không được bỏ trống');
          }
        }
      }
    });

    const payload = _.assign({}, this.model) || {};
    if (check) {
      if (this.payload_tmp.phone) {
        payload.phone = this.payload_tmp.phone;
      }
      if (this.payload_tmp.email) {
        payload.email = this.payload_tmp.email;
      }
      if (payload.tags && payload.tags.length > 0) {
        const _tags_arr = [];
        payload.tags.forEach(t => {
          _tags_arr.push(t.displayValue);
        });
        const _tags = _tags_arr.length > 0 ? _tags_arr.join(',') : null;
        payload.tags = _tags;
      }
      if (this.user.role != 'administrator') {
        delete payload.role;
        delete payload.access;
        delete payload.group_id;
      }
      if (payload.city_id) {
        this.is_load_district_follow_city = true;
      }

      if (payload.phone && !UtilityService.isNumeric(payload.phone)) {
        this.errorUpdate.push('Số điện thoại không hợp lệ');
      }

      if (payload.email && !UtilityService.validateEmail(payload.email)) {
        this.errorUpdate.push('Email không hợp lệ');
      }

      console.log(payload, 'payload');

      if (payload.$addToSet) {
        if (payload.$addToSet.sub_phone) {
          if (!UtilityService.isNumeric(payload.$addToSet.sub_phone)) {
            this.errorUpdate.push('Số điện thoại không hợp lệ');
          }
        }
        if (payload.$addToSet.sub_email) {
          if (!UtilityService.validateEmail(payload.$addToSet.sub_email)) {
            this.errorUpdate.push('Email không hợp lệ');
          }
        }
      }
      if (payload.$pull) {
        if (payload.$pull.sub_phone) {
          if (!UtilityService.isNumeric(payload.$pull.sub_phone)) {
            this.errorUpdate.push('Số điện thoại không hợp lệ');
          }
        }
        if (payload.$pull.sub_email) {
          if (!UtilityService.validateEmail(payload.$pull.sub_email)) {
            this.errorUpdate.push('Email không hợp lệ');
          }
        }
      }
    }

    if (payload.dob) {
      payload.dob = moment(payload.dob).format('YYYY-MM-DD');
    }

    if (payload.more_phone) {
      delete payload.more_phone;
    }
    if (payload.more_email) {
      delete payload.more_email;
    }
    if (payload.more_facebook) {
      delete payload.more_facebook;
    }
    // Xóa sub_xxx để k lỗi MongoDB
    if (payload.sub_phone) {
      delete payload.sub_phone;
    }
    if (payload.sub_email) {
      delete payload.sub_email;
    }
    if (payload.facebook) {
      delete payload.facebook;
    }

    if (this.errorUpdate.length == 0) {
      this.userService.update(this.owner._id, payload).subscribe(
        res => {
          setTimeout(() => {
            this.is_load_data = false;
            this.is_load_district_follow_city = false;
          }, 1000);
          if (this.user._id == res.data._id) {
            this.userService.updateCurentTime(res.data);
          }
          if (res.status == 200 && res.error == false) {
            if (this.model.more_phone) {
              if (!this.model.phone) {
                this.model.phone = this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '');
              } else {
                if (this.model.sub_phone && this.model.sub_phone.length > 0) {
                  this.model.sub_phone.push(this.model.more_phone.trim().replace(new RegExp(' ', 'g'), ''));
                } else {
                  this.model.sub_phone = [this.model.more_phone.trim().replace(new RegExp(' ', 'g'), '')];
                }
              }
            }
            delete this.model.more_phone;
            if (this.model.more_email) {
              if (!this.model.email) {
                this.model.email = this.model.more_email.trim().replace(new RegExp(' ', 'g'), '');
              } else {
                if (this.model.sub_email && this.model.sub_email.length > 0) {
                  this.model.sub_email.push(this.model.more_email.trim().replace(new RegExp(' ', 'g'), ''));
                } else {
                  this.model.sub_email = [this.model.more_email.trim().replace(new RegExp(' ', 'g'), '')];
                }
              }
            }
            delete this.model.more_email;
            if (this.model.more_facebook) {
              if (this.model.facebook && this.model.facebook.length > 0) {
                this.model.facebook.push(this.model.more_facebook.trim().replace(new RegExp(' ', 'g'), ''));
              } else {
                this.model.facebook = [this.model.more_facebook.trim().replace(new RegExp(' ', 'g'), '')];
              }
            }
            delete this.model.more_facebook;

            this.addPhone = false;
            this.addEmail = false;
            this.addFacebook = false;
            this.deletePhone = true;
            this.deleteEmail = true;
            this.deleteFacebook = true;
            this.model.$addToSet = {};
            this.model.$pull = {};
            this.toastr.info('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.comeback.emit({
              requester_id: this.owner._id,
            });
            console.log('data emit', res.data);
            this.shareService.onUserUpdated.emit(res.data);
          } else {
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        },
        err => {
          setTimeout(() => {
            this.is_load_data = false;
            this.is_load_district_follow_city = false;
          }, 1000);
          this.toastr.error(err.message, 'Lưu không thành công', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        }
      );
    } else {
      this.addPhone = false;
      this.addEmail = false;
      this.addFacebook = false;
      this.model.$addToSet = {};
      this.model.$pull = {};
      this.errorUpdate.forEach(e => {
        this.toastr.error(e, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      });
    }
  }

  // function for result template
  public templateResult: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (state.id == 'add') {
      return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>');
    } else {
      return state.text;
    }
  };

  // function for selection template
  public templateSelection: Select2TemplateFunction = (state: Select2OptionData): JQuery | string => {
    if (state.id == 'add') {
      return jQuery('<i class="icon fa fa-plus"></><span class="ml-10">' + state.text + '</span>');
    } else {
      return state.text;
    }
  };

  copyClipboard(inputChar: string) {
    // Get the text field
    const temp = $('<input>');
    $('body').append(temp);
    temp.val(inputChar).select();
    document.execCommand('copy');
    temp.remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/user/detail_user.component.ts